export const links = [{
  name: '安装',
  path: '/installation'
}, {
  name: '简介',
  path: '/'
}, {
  name: '上手',
  path: '/started'
}, {
  name: '布局',
  children: [
    {
      name: '基础布局',
      path: '/layou/basic'
    },
    {
      name: '并排布局',
      path: '/layou/abreast'
    },
    {
      name: '响应式',
      path: '/layou/responsive'
    }
  ]
}, {
  name: '图层',
  children: [
    {
      name: '概念',
      path: '/layer/concepts'
    },
    {
      name: '第一个图层',
      path: '/layer/frist'
    },
    {
      name: '多图层',
      path: '/layer/more'
    },
    {
      name: '图层类型',
      path: '/layer/type'
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/layou/sidebar-link.js